// extracted by mini-css-extract-plugin
export default {"steps":"stepperVertical_steps__mJzGb","steps_step":"stepperVertical_steps_step__mRXLn","steps_step_circle":"stepperVertical_steps_step_circle__dM2Y+"};